/* ==========================================================================
   YOPPY — lightweight EU cookie-consent banner. No third-party scripts, no
   tracking. Choice is stored in localStorage only. The site itself sets no
   advertising cookies; this banner is informational + GDPR-friendly.
   ========================================================================== */
(function () {
  "use strict";

  var KEY = "yoppy-cookie-consent";

  function t(source) {
    return (window.mermerI18n && window.mermerI18n.translate)
      ? window.mermerI18n.translate(source)
      : source;
  }

  function alreadyChosen() {
    try {
      return Boolean(window.localStorage.getItem(KEY));
    } catch (e) {
      return false;
    }
  }

  function remember(choice) {
    try {
      window.localStorage.setItem(KEY, choice);
    } catch (e) {
      /* ignore storage errors */
    }
  }

  function build() {
    if (alreadyChosen()) return;

    var banner = document.createElement("div");
    banner.className = "cookie-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-live", "polite");
    banner.setAttribute("aria-label", "Cookie notice");
    banner.innerHTML =
      '<p class="cookie-text">' +
      t("We use only essential cookies and local storage to run this site and remember your cart and language. No tracking.") +
      ' <a href="/pages/cookie-policy">' + t("Cookie Policy") + "</a>" +
      "</p>" +
      '<div class="cookie-actions">' +
      '<button type="button" class="btn btn-ghost cookie-decline">' + t("Decline") + "</button>" +
      '<button type="button" class="btn btn-primary cookie-accept">' + t("Accept") + "</button>" +
      "</div>";

    banner.querySelector(".cookie-accept").addEventListener("click", function () {
      remember("accepted");
      banner.remove();
    });
    banner.querySelector(".cookie-decline").addEventListener("click", function () {
      remember("declined");
      banner.remove();
    });

    document.body.appendChild(banner);
    if (window.mermerI18n && window.mermerI18n.apply) {
      window.mermerI18n.apply(banner);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", build);
  } else {
    build();
  }
})();
